import { render, staticRenderFns } from "./modalEditTermsAndConditions.vue?vue&type=template&id=07ce09d4&"
import script from "./modalEditTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./modalEditTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports